// Route: /pricing — публичная страница тарифов.
import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { PricingPage } from "@/components/public/pricing-page";
import { PageMeta } from "@/components/seo/PageMeta";
import { isCommerceVisible } from "@/lib/module-availability/commerce";

const searchSchema = z.object({
	cycle: z.enum(["monthly", "annual"]).optional(),
});

export const Route = createFileRoute("/pricing")({
	// Гейт коммерции: когда продажа скрыта, роут не должен существовать даже по
	// прямой ссылке. Проверка в `beforeLoad`, а не в компоненте, — чтобы страница
	// не мигнула тарифами перед редиректом.
	beforeLoad: () => {
		if (!isCommerceVisible()) throw redirect({ to: "/" });
	},
	validateSearch: tolerantSearch(searchSchema),
	component: PricingRoutePage,
});

function PricingRoutePage(): React.ReactElement {
	const search = Route.useSearch();
	const { t } = useTranslation(["pricing", "layout"]);
	return (
		<>
			<PageMeta
				title={t("layout:nav.pricing")}
				description={t("pricing:hero.subtitle")}
				path="/pricing"
			/>
			<PricingPage initialCycle={search.cycle ?? "monthly"} />
		</>
	);
}
